/* Lunette — cart page: our rows live inside the cart, and stay current.
   The theme lays the cart out as a grid (title, line items, summary, "more blocks"). Our rows are
   separate sections, so by default they render below the whole grid — under the summary on a
   phone, below the fold on desktop. This moves them into the theme's own "more blocks" slot
   (left column, under the line items) and, whenever the theme re-renders the cart after a
   quantity change, fetches fresh HTML for them through Shopify's section rendering so the
   second-cup offer, the add-ons and the shipping line always match the cart.
   Installed from layout/theme.liquid; does nothing off the cart page. */
(function () {
  if (window.__lunCartSyncBound) return;
  window.__lunCartSyncBound = true;
  var KEYS = ['lun_cart_shipping', 'lun_cart_tiers', 'lun_cart_upsell', 'lun_cart_trust', 'lun_cart_sticky'];
  var kept = [];      // our section elements, held even while the theme's re-render detaches them
  var refreshing = null;

  // 27 Oct cart order: proof + free-shipping card first in the item list (under the title), offers between the
  // items and the totals, USPs + payment methods at the end of the summary (under the checkout button).
  function slot() { return document.querySelector('.cart-page__more-blocks'); }
  function anchorFor(el) {
    if (/__lun_cart_shipping$/.test(el.id)) return { box: document.querySelector('.cart-page__items'), first: true };
    if (/__lun_cart_trust$/.test(el.id)) return { box: document.querySelector('.cart-page__summary'), first: false };
    return null;
  }
  function isPlaced(el) {
    var a = anchorFor(el);
    if (a && a.box) return a.first ? a.box.firstElementChild === el : a.box.lastElementChild === el;
    return el.parentNode === slot();
  }
  function place() {
    var s = slot(); if (!s) return false;
    kept.forEach(function (el) {
      if (isPlaced(el)) return;
      var a = anchorFor(el);
      if (a && a.box) { if (a.first) a.box.insertBefore(el, a.box.firstChild); else a.box.appendChild(el); }
      else s.appendChild(el);
    });
    return true;
  }
  function refresh() {
    if (!kept.length) return;
    var ids = kept.map(function (el) { return el.id.replace(/^shopify-section-/, ''); });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // plain request: an Accept: application/json header makes Shopify answer with cart.js instead
    fetch(root + 'cart?sections=' + ids.join(','))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        kept.forEach(function (el, i) {
          var html = data[ids[i]]; if (typeof html !== 'string') return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.shopify-section') || doc.body;
          el.innerHTML = fresh.innerHTML;
          // inline <script> tags do not run through innerHTML: re-create them
          el.querySelectorAll('script').forEach(function (old) {
            var n = document.createElement('script'); n.textContent = old.textContent; old.replaceWith(n);
          });
        });
        place();
      })
      .catch(function () {});
  }
  function scheduleRefresh() {
    clearTimeout(refreshing);
    refreshing = setTimeout(refresh, 150);
  }
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  function init() {
    if (!onCartPage()) return;
    kept = KEYS.map(function (k) { return document.querySelector('.shopify-section[id$="__' + k + '"]'); }).filter(Boolean);
    if (!kept.length || !place()) return;
    var cartEl = document.querySelector('cart-items-component') || document.body;
    // The theme swaps the cart's HTML after a quantity change; our nodes fall out. Put them back, then fetch fresh copies.
    new MutationObserver(function () {
      var s = slot();
      if (s && kept.some(function (el) { return !isPlaced(el); })) { place(); scheduleRefresh(); }
    }).observe(cartEl, { childList: true, subtree: true });    document.addEventListener('cart:update', function (e) {
      var d = e && e.detail && e.detail.data;
      if (d && d.source === 'product-form-component') return; // that one navigates here anyway
      place(); scheduleRefresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Store-credit emails (October 2026): a link ending in ?apply=LPXC,LPXCSHIP applies both codes through the
   cart API. Shopify's own /discount/CODE link takes one code, and the credit needs its free-shipping partner
   so a 50 € basket still ships free after the 10 € (the email promises it). Letters, digits and commas only;
   the parameter leaves the address afterwards. Runs on every page, once. */
(function () {
  if (window.__lunApplyCodesBound) return;
  window.__lunApplyCodesBound = true;
  var params = new URLSearchParams(window.location.search);
  var codes = params.get('apply');
  if (!codes || !/^[A-Za-z0-9]+(,[A-Za-z0-9]+){0,4}$/.test(codes)) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // cart/update.js sets the cart's codes (it replaces any others, as Shopify's own /discount/ link does too).
  fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: codes }) })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      // Only a confirmed cart drops ?apply=: otherwise a reload of the same address retries.
      var held = ((cart && cart.discount_codes) || []).map(function (d) { return String(d.code).toUpperCase(); });
      var all = codes.toUpperCase().split(',').every(function (c) { return held.indexOf(c) !== -1; });
      if (!all) return;
      params.delete('apply');
      var q = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
    })
    .catch(function () { /* the /discount/ link has already applied the credit itself */ });
})();
